<template>
  <div class="t-app__container">
    <heading :overTitle="$t('business-admin-dashboard-overTitle')" :title="$t('business-admin-dashboard-title')" :text="$t('business-admin-dashboard-text')" />
    <div class="h-section h-section--small-top">
      <admin-dashboard-tabs />
      <dashboard-section :title="$t('dashboard-admin-business-title')">
        <s-form>
          <p class="a-form-control">
            <s-form class="search-business" @submit="searchBusiness">
              <input class="search-business__input" v-model="searchTerm" v-focus />
              <button type="button" class="search-business__erase" v-if="searchTerm.length > 0" @click="clearSearch" />
              <button class="search-business__btn" type="submit">{{ $t('search-business-btn') }}</button>
            </s-form>
          </p>
        </s-form>
        <div v-if="searchResultReceived && business.length > 0">
          <admin-business-list :value="business" @businessUpdated="businessUpdated" />
        </div>
        <span v-if="searchResultReceived && business.length === 0">{{ $t('search-business-noresult') }}</span>
      </dashboard-section>
    </div>
  </div>
</template>

<script>
import Heading from '@/components/heading'
import SForm from '@/components/form/form'
import AdminDashboardTabs from '@/components/dashboard/admin-dashboard-tabs'
import AdminBusinessList from '@/components/dashboard/admin-business/admin-business-list'
import DashboardSection from '@/components/dashboard/dashboard-section'

import LoaderService from '@/services/loader'
import BusinessService from '@/services/business'

export default {
  components: {
    Heading,
    SForm,
    AdminDashboardTabs,
    AdminBusinessList,
    DashboardSection
  },
  data() {
    return {
      business: [],
      searchResultReceived: false,
      searchTerm: ''
    }
  },
  methods: {
    searchBusiness: async function() {
      let response = []
      LoaderService.showLoader()

      if (this.searchTerm !== '') {
        response = await BusinessService.adminSearchBusiness(this.searchTerm)
      }

      this.business = response
      this.searchResultReceived = true
      LoaderService.hideLoader()
    },
    clearSearch: function() {
      this.searchTerm = ''
    },
    businessUpdated: function(updatedBusiness) {
      const updatedBusinessIndex = this.business.findIndex(business => business.Id === updatedBusiness.Id)
      Object.assign(this.business[updatedBusinessIndex], updatedBusiness)
    }
  },
  directives: {
    focus: {
      inserted: function(el) {
        el.focus()
      }
    }
  }
}
</script>

<style lang="scss">
.search-business {
  align-items: center;
  display: flex;
  margin-top: -8px;
  position: relative;

  &__input {
    border: 0;
    color: inherit;
    height: 100%;
    outline: none;
    width: calc(100% - 50px);
  }

  &__btn {
    appearance: none;
    background: #7667a7 url(~@/assets/search.svg) no-repeat center center;
    background-size: 30px 30px;
    border: 0;
    border-radius: 0px 4px 4px 0px;
    color: transparent;
    cursor: pointer;
    font: 0/0 a;
    height: 50px;
    padding: 0;
    position: relative;
    right: -16px;
    text-shadow: none;
    white-space: nowrap;
    width: 50px;
  }

  &__erase {
    @include btn-default-properties;
    background-size: contain;
    color: transparent;
    font: 0/0 a;
    text-shadow: none;
    white-space: nowrap;
    height: 30px;
    width: 30px;
    background: color('white') url(~@/assets/close-black.svg) no-repeat center center;
    background-size: 16px 16px;
    border-radius: 4px;
    border: 1px solid transparent;
    transition: border-color 0.25s ease;

    &:hover {
      border-color: color('black');
    }
  }
}
</style>
